import axios from "axios";
import { fpoProfileUrl } from "../constants/apis";
import { getAuthToken } from "../helpers/local_storage_helpers";

const authHeaders = () => ({
    headers: { Authorization: `Token ${getAuthToken()}` },
});

/**
 * GET /fpo/profile/  — fetch full FPO profile
 */
export const getFPOProfile = async () => {
    const response = await axios.get(fpoProfileUrl, authHeaders());
    return response;
};

/**
 * PATCH /fpo/profile/  — partial update of FPO profile
 * @param {FormData|Object} data  – pass FormData if uploading files, plain object otherwise
 */
export const patchFPOProfile = async (data) => {
    const isFormData = data instanceof FormData;
    const config = {
        ...authHeaders(),
        headers: {
            ...authHeaders().headers,
            "Content-Type": isFormData ? "multipart/form-data" : "application/json",
        },
    };
    const response = await axios.patch(fpoProfileUrl, data, config);
    return response;
};
